import React from 'react';
import InformationModal from './InformationModal';

export default (props) => (
	<div className="form-element ">
		<label className={`input input-text ${props.error && (props.displayError || (props.value !== undefined && props.value !== null)) ? 'error' : ''} ${props.disabled ? 'disabled' : ''}`}>
			< div className={`label ${props.bold && 'bold-label'}`}>{props.label}{props.information && <InformationModal informationText="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua." informationTitle="Info title" />}</div>
			<div className="group" data-label="">
				<input
					type="text"
					{...props}

				/>
			</div>
			<span className="input-message">
				<p className="message">{((props.value !== undefined && props.value !== null) || props.displayError) && (props.error || props.message)}</p>
			</span>
		</label>
	</div >
)